import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUser = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsxs("g", {
			transform: "translate(0.9143 0) scale(0.9143)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M14.4903 19.8023 C10.2635 19.8022 6.5047 21.8431 4.1116 25.0102 C3.5965 25.6918 3.339 26.0326 3.3474 26.4933 C3.3539 26.8491 3.5774 27.298 3.8574 27.5179 C4.2199 27.8022 4.7221 27.8022 5.7266 27.8022 L23.254 27.8022 C24.2584 27.8022 24.7607 27.8023 25.1231 27.5178 C25.4031 27.2981 25.6266 26.8491 25.6331 26.4933 C25.6416 26.0326 25.384 25.6919 24.869 25.0101 C22.4759 21.8431 18.7171 19.8022 14.4903 19.8023 Z",
					stroke: "white",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.4903 15.8022 C17.804 15.8022 20.4902 13.1159 20.4902 9.8023 C20.4903 6.4885 17.804 3.8022 14.4903 3.8022 C11.1765 3.8022 8.4903 6.4885 8.4903 9.8022 C8.4902 13.116 11.1765 15.8022 14.4903 15.8022 Z",
					stroke: "white",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.4903 19.8023 C10.2635 19.8022 6.5047 21.8431 4.1116 25.0102 C3.5965 25.6918 3.339 26.0326 3.3474 26.4933 C3.3539 26.8491 3.5774 27.298 3.8574 27.5179 C4.2199 27.8022 4.7221 27.8022 5.7266 27.8022 L23.254 27.8022 C24.2584 27.8022 24.7607 27.8023 25.1231 27.5178 C25.4031 27.2981 25.6266 26.8491 25.6331 26.4933 C25.6416 26.0326 25.384 25.6919 24.869 25.0101 C22.4759 21.8431 18.7171 19.8022 14.4903 19.8023 Z",
					style: { fill: "var(--sticker-pastel,#D1D7B3)" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.4903 15.8022 C17.804 15.8022 20.4902 13.1159 20.4902 9.8023 C20.4903 6.4885 17.804 3.8022 14.4903 3.8022 C11.1765 3.8022 8.4903 6.4885 8.4903 9.8022 C8.4902 13.116 11.1765 15.8022 14.4903 15.8022 Z",
					style: { fill: "var(--sticker-pastel,#D1D7B3)" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.4903 19.8023 C10.2635 19.8022 6.5047 21.8431 4.1116 25.0102 C3.5965 25.6918 3.339 26.0326 3.3474 26.4933 C3.3539 26.8491 3.5774 27.298 3.8574 27.5179 C4.2199 27.8022 4.7221 27.8022 5.7266 27.8022 L23.254 27.8022 C24.2584 27.8022 24.7607 27.8023 25.1231 27.5178 C25.4031 27.2981 25.6266 26.8491 25.6331 26.4933 C25.6416 26.0326 25.384 25.6919 24.869 25.0101 C22.4759 21.8431 18.7171 19.8022 14.4903 19.8023 Z",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5,
					style: { stroke: "var(--sticker-dark,#5F6F27)" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.4903 15.8022 C17.804 15.8022 20.4902 13.1159 20.4902 9.8023 C20.4903 6.4885 17.804 3.8022 14.4903 3.8022 C11.1765 3.8022 8.4903 6.4885 8.4903 9.8022 C8.4902 13.116 11.1765 15.8022 14.4903 15.8022 Z",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5,
					style: { stroke: "var(--sticker-dark,#5F6F27)" }
				})
			]
		})
	});
};
export default SvgUser;
